import axios from "axios";
import baseUrl from "../config/baseURL";
import { getAuthToken } from "../services/auth";

export const getCustomers = async (organization_id: any) => {
  let token = await getAuthToken();
  try {
    if (token) {
      let header_token = "Bearer " + token.data;
      const headers = { Authorization: header_token };

      try {
        const endpoint = `${baseUrl}/core/organizations/${organization_id}/customers/`;
        console.log('customer endpoint', endpoint);
        const response = await axios.get(endpoint, { headers });
        console.log('customer response', response);

        if (response.status >= 200 && response.status <= 400) {
          return { success: true, data: response?.data };
        } else {
          console.error("Data retrieval failed:", response.data);
          return { success: false, data: response?.data };
        }
      } catch (error) {
        console.error("An unexpected error occurred:", error);
        return { success: false, data: error };
      }
    } else {
      return { success: false, data: "error: Token does not exist" };
    }
  } catch (error) {
    console.error("Unexpected error:", error);
    return { success: false, data: undefined };
  }
};

export const getCustomerById = async (organization_id: any, customer_id: any) => {
  let token = await getAuthToken();
  try {
    if (token) {
      let header_token = "Bearer " + token.data;
      const headers = { Authorization: header_token };

      try {
        const endpoint = `${baseUrl}/core/organizations/${organization_id}/customers/${customer_id}/`;
        const response = await axios.get(endpoint, { headers });

        if (response.status >= 200 && response.status <= 400) {
          return { success: true, data: response?.data };
        } else {
          console.error("Data retrieval failed:", response.data);
          return { success: false, data: response?.data };
        }
      } catch (error) {
        console.error("An unexpected error occurred:", error);
        return { success: false, data: error };
      }
    } else {
      return { success: false, data: "error: Token does not exist" };
    }
  } catch (error) {
    console.error("Unexpected error:", error);
    return { success: false, data: undefined };
  }
};

export const createCustomer = async (organization_id: any, payload: any) => {
  let token = await getAuthToken();
  try {
    if (token) {
      let header_token = "Bearer " + token.data;
      const headers = { Authorization: header_token };

      try {
        const endpoint = `${baseUrl}/core/organizations/${organization_id}/customers/`;
        const response = await axios.post(endpoint, payload, { headers });

        if (response.status >= 200 && response.status <= 400) {
          return { success: true, data: response?.data };
        } else {
          console.error("Creation failed:", response.data);
          return { success: false, data: response?.data };
        }
      } catch (error) {
        console.error("An unexpected error occurred:", error);
        return { success: false, data: error };
      }
    } else {
      return { success: false, data: "error: Token does not exist" };
    }
  } catch (error) {
    console.error("Unexpected error:", error);
    return { success: false, data: undefined };
  }
};

export const updateCustomer = async (organization_id: any, customer_id: any, payload: any) => {
  let token = await getAuthToken();
  try {
    if (token) {
      let header_token = "Bearer " + token.data;
      const headers = { Authorization: header_token };

      try {
        const endpoint = `${baseUrl}/core/organizations/${organization_id}/customers/${customer_id}/`;
        const response = await axios.put(endpoint, payload, { headers });

        if (response.status >= 200 && response.status <= 400) {
          return { success: true, data: response?.data };
        } else {
          console.error("Update failed:", response.data);
          return { success: false, data: response?.data };
        }
      } catch (error) {
        console.error("An unexpected error occurred:", error);
        return { success: false, data: error };
      }
    } else {
      return { success: false, data: "error: Token does not exist" };
    }
  } catch (error) {
    console.error("Unexpected error:", error);
    return { success: false, data: undefined };
  }
};

export const deleteCustomer = async (organization_id: any, customer_id: any) => {
  let token = await getAuthToken();
  try {
    if (token) {
      let header_token = "Bearer " + token.data;
      const headers = { Authorization: header_token };

      try {
        const endpoint = `${baseUrl}/core/organizations/${organization_id}/customers/${customer_id}/`;
        const response = await axios.delete(endpoint, { headers });

        if (response.status >= 200 && response.status <= 400) {
          return { success: true, data: response?.data };
        } else {
          console.error("Delete failed:", response.data);
          return { success: false, data: response?.data };
        }
      } catch (error) {
        console.error("An unexpected error occurred:", error);
        return { success: false, data: error };
      }
    } else {
      return { success: false, data: "error: Token does not exist" };
    }
  } catch (error) {
    console.error("Unexpected error:", error);
    return { success: false, data: undefined };
  }
};

export const getCustomerFromLead = async (organization_id: any, lead_id: any, payload: any = {}) => {
  let token = await getAuthToken();
  try {
    if (token) {
      let header_token = "Bearer " + token.data;
      const headers = { Authorization: header_token };

      try {
        const endpoint = `${baseUrl}/core/organizations/${organization_id}/customers/from-lead/${lead_id}/`;
        const response = await axios.post(endpoint, payload, { headers });

        if (response.status >= 200 && response.status <= 400) {
          return { success: true, data: response?.data };
        } else {
          console.error("Customer from lead creation failed:", response.data);
          return { success: false, data: response?.data };
        }
      } catch (error) {
        console.error("An unexpected error occurred:", error);
        return { success: false, data: error };
      }
    } else {
      return { success: false, data: "error: Token does not exist" };
    }
  } catch (error) {
    console.error("Unexpected error:", error);
    return { success: false, data: undefined };
  }
};